<template>
  <div>
    <div
      class="list-group-item d-flex align-items-center"
      :class="itemClass"
      @click="sectorClicked(sector)"
    >
      <feather :type="isParent?'folder': isSelected?'check-square':'square'" />
      <div class="w-100">
        {{ sector.name }}
      </div>
    </div>
    <div
      v-if="showChildren && isParent"
      class="ml-5"
    >
      <SectorSelectionSectorItem
        v-for="c in sector.children"
        :sector="c"
        :max-selection="maxSelection"
        :selected-ids="selectedIds"
        :selected-parent-ids="selectedParentIds"
        @selected="$emit('selected',$event)"
        @removed="$emit('removed',$event)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'SectorSelectionSectorItem',
  props: {
    sector: {},
    maxSelection: 0,
    selectedIds: [],
    selectedParentIds: []
  },
  emits: ['selected', 'removed'],
  data() {
    return {
      showChildren: false
    }
  },
  computed: {
    isParent() {
      return this.sector && this.sector.children && this.sector.children.length > 0;
    },
    isSelected() {
      return this.selectedIds.indexOf(this.sector.id) > -1;
    },

    isSelectedParent() {
      return this.selectedParentIds.indexOf(this.sector.id) > -1;
    },
    itemClass() {
      let className = [];
      if (this.isParent) {
        className.push('font-weight-bold ')
        if (this.isSelectedParent) {
          className.push('text-primary');
        } else {
          className.push('text-dark');
        }
      } else {

        if (this.isSelected) {
          className.push('text-primary');
        } else {
          if (this.selectedIds.length < this.maxSelection) {
            className.push('text-dark');
          } else {
            className.push('text-secondary');
          }
        }
      }
      return className;
    }


  },
  methods: {
    sectorClicked(sector) {
      if (this.isParent) {
        this.showChildren = !this.showChildren;
      } else {
        if (this.isSelected) {
          this.$emit('removed', sector);
        } else {
          if (this.selectedIds.length < this.maxSelection) {
            this.$emit('selected', sector);
          }
        }
      }
    },
  }
}
</script>
